



























































































































































































const { AgGridVue } = require('ag-grid-vue');
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import vuee from 'vue';
import { Vue, Component, Watch } from 'vue-property-decorator';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import { LoadingService } from '@/services/loadingService';
import moment from 'moment';
import HtmlTemplateForm from '@/pantallas/ConfigurarBase/HtmlTemplateForm.vue';
import { fetchCamaraModulo } from '@/pantallas/Camaras/fetchCamaraModulos';
import '../ClassAggrid.css';
import showVideo from '../showVideo.vue';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  CellContextMenuEvent,
} from 'ag-grid-community';
import axios from 'axios';
import { toInteger } from 'lodash';

@Component({
  components: {
    DateComponent: DatePicker,
    TimeComponent: TimePicker,
    GridComponent: AgGridVue,
    HtmlTemplateForm,
    showVideo,
    FormFieldsContainer,
  },
})
export default class CamaraHistorico extends Vue {
  // State
  readonly urlConverter: string =
    'https://test.awsgpschile.com/ms/videoconverter';
  infoItems: any[] = [];
  show: boolean = false;
  link: string = 'https://ms.awsgpschile.com/v/view/camara/';
  loadingService = new LoadingService();
  dateString = new Date();
  $snotify: any;
  patente: string = '';
  search: string = '';
  formFields: {
    patent: any;
    channels: any;
    camera_id: any;
    patente: any;
    dateStart: any;
    timeStart: any;
    dateEnd: any;
    timeEnd: any;
  } = {
    patent: {
      label: 'Flotas',
      value: '',
      items: [],
      patent: '',
    },
    channels: {
      label: 'Canal',
      value: '',
      items: [],
    },
    camera_id: {
      label: 'Id Cámara',
      value: '',
      items: [],
    },
    patente: {
      label: 'Barcaza',
      value: '',
      items: [],
    },
    dateStart: {
      label: 'Fecha Desde',
      value: moment(
        this.dateString.getFullYear() +
          '-' +
          (this.dateString.getMonth() + 1).toString() +
          '-' +
          this.dateString.getDate()
      ),
    },
    timeStart: {
      label: 'Hora Desde',
      value: moment('00:00', 'HHmm'),
    },
    dateEnd: {
      label: 'Fecha Hasta',
      value: moment(
        this.dateString.getFullYear() +
          '-' +
          (this.dateString.getMonth() + 1).toString() +
          '-' +
          this.dateString.getDate()
      ),
    },
    timeEnd: {
      label: 'Hora Hasta',
      value: moment('23:59', 'HHmm'),
    },
  };
  gridOptions: GridOptions;
  columnDefs: Array<ColDef> = [];
  gridApi: GridApi;
  columnApi: ColumnApi;
  localeText: any = {};
  htmlExample: any = '';
  openVideo: boolean = false;
  videoUrl: string = '';
  titleDialog: string = '';
  isDownload: boolean = true;
  countSelect: number = 0;
  checkAllFlotas: boolean = false;
  checkAllVehiculos: boolean = false;
  cssWithOutVideo: {} = {
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'start',
  };
  cssWithVideo: {} = {
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'start',
    cursor: 'pointer',
  };
  serverSide: any;
  startDateFetch: any = '';
  endDateFetch: any = '';
  cameraFetch: any = '';
  patentFetch: any = '';
  hashPage: string = '';

  // Methods

  constructor() {
    super();

    this.columnDefs = [
      {
        headerName: 'Barcaza',
        field: 'barcaza',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Flota',
        field: '__nom_flota',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Patente',
        field: 'patente',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Dirección Mac',
        field: 'mac_camara',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Fecha',
        field: 'fecha_ingreso',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Imágenes',
        field: 'imagenes',
        sortable: false,
        resizable: false,
        width: 100,
        lockPinned: true,
        cellRenderer: this.handleCellRenderer,
        cellStyle: () => {
          return { cursor: 'pointer' };
        },
        onCellClicked: this.handleClickInfo,
      },
    ];

    this.gridOptions = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 50, //Solución Paginación
      cacheBlockSize: 50, //Solución Paginación //Ordenamiento + Seleccion
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCellSelection: false,
      localeText: this.localeText,
      onGridReady: this.onGridReady,

      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,

      columnDefs: this.columnDefs,
      suppressCopyRowsToClipboard: true,
      onGridSizeChanged: event => {
        event.api.sizeColumnsToFit();
      },
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      alwaysShowVerticalScroll: false,
      // onSelectionChanged: this.onSelectionChanged,
      onRowSelected: this.onSelectionRow,
      //onCellClicked: this.onSelectionRow,
      // onCellMouseOver: this.mouseOverEvent,
      // onCellMouseOut: this.mouseOverOut,
      isExternalFilterPresent: this.isExternalFilterPresent,
      doesExternalFilterPass: this.doesExternalFilterPass,
      blockLoadDebounceMillis: 350,
      //onDragStopped: this.onDragStoppedEvent,
      //onColumnPinned: this.onColumnPinnedEvent,
      columnTypes: {},
      suppressCsvExport: true,
      suppressExcelExport: true,
    };
  }

  mounted() {
    this.chargeFlotasCamera();
    this.chargePatentsCamera();
    this.gridApi.showNoRowsOverlay();
  }

  handleCellRenderer(event: any) {
    if (event.value.length == 0) {
      return '<i class="material-icons" id="5545" title="Ver Filtros" style="width: 28px; height: 28px; margin-top: 10%" >warning</i>';
    }
    return '<i class="material-icons" id="5545" title="Ver Filtros" style="width: 28px; height: 28px; margin-top: 10%" >info_outlined</i>';
  }

  handleClickInfo(event: any) {
    var itemsInfo: any[] = [];
    if (
      event.value != '' &&
      event.value != undefined &&
      event.value != null &&
      event.value.length > 0
    ) {
      for (var key in event.value) {
        if (event.value.hasOwnProperty(key)) {
          itemsInfo.push({ key: key, value: event.value[key] });
        }
      }
      this.infoItems = itemsInfo;
      this.patente = event.data.patente;
      // console.log(event);
      // console.log(this.infoItems);
      this.show = true;
    } else {
      this.$snotify.error('No hay imágenes disponibles.');
    }
  }

  handleSearch(event: string) {
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  onSelectionRow() {
    // console.log(this.gridApi.getSelectedRows().length)
    this.countSelect = this.gridApi.getSelectedRows().length;
  }
  // onSelectionChanged(){
  //   console.log('2')
  // }

  async downdloadSelected() {
    for (let index = 0; index < this.countSelect; index++) {
      this.loadingService.showLoading();
      var temp = this.gridApi.getSelectedRows()[index];
      var video: string = await this.getVideo(temp.url, temp.url_converter);
      window.open(video);
      this.loadingService.hideLoading();
    }
  }

  selectAllFlota() {
    var temp: any = [];
    if (this.checkAllFlotas) {
      this.formFields.patent.items.forEach((x: any) => {
        temp.push(x.cod_flota);
      });
    } else {
      temp = [];
    }
    this.formFields.patent.value = temp;
  }
  selectAllVehiculos() {
    var temp: any = [];
    if (this.checkAllVehiculos) {
      this.formFields.patente.items.forEach((x: any) => {
        temp.push(x.cod_vehiculo);
      });
    } else {
      temp = [];
    }
    this.formFields.patente.value = temp;
  }

  confirmFlotas() {
    if (
      this.formFields.patent.value.length < this.formFields.patent.items.length
    ) {
      this.checkAllFlotas = false;
    } else {
      this.checkAllFlotas = true;
    }
    this.formFields.patente.value = [];
    this.checkAllVehiculos = false;
    this.chargePatentsCamera();
  }

  confirmVehiculos() {
    if (
      this.formFields.patente.value.length <
      this.formFields.patente.items.length
    ) {
      this.checkAllVehiculos = false;
    } else {
      this.checkAllVehiculos = true;
    }
  }

  async onGridReady(params: GridReadyEvent) {
    this.loadingService.showLoading();
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    var self = this;

    this.serverSide = {
      getRows(params: any): void {
        params.request.paginationSize = self.gridOptions.cacheBlockSize;

        var body: any = {
          //id_cliente: this.getClientID().toString(),
          id_cliente: self.getClientID().toString(),
          id_usuario: self.getUserID().toString(),
          start_date: moment(self.startDateFetch)
            .format('YYYY-MM-DD')
            .toString(),
          ending_date: moment(self.endDateFetch)
            .format('YYYY-MM-DD')
            .toString(),
          start_hour: moment(self.formFields.timeStart.value)
            .format('HH:mm:ss')
            .toString(),
          ending_hour: moment(self.formFields.timeEnd.value)
            .format('HH:mm:ss')
            .toString(),
          patente: self.patentFetch,
          flotas: self.formFields.patent.value,
          patentes: self.formFields.patente.value,
          search: self.search,
        };

        if (self.hashPage != '') {
          body['hash'] = this.hashPage;
        }

        body = Object.assign({}, body, params.request);

        fetchCamaraModulo(body, 'getCamaraHik')
          .then((response: any) => {
            if (response.data.CODIGO_RESPUESTA == '1') {
              self.hashPage = 'hash' in response.data ? response.data.hash : '';
              if (response.data.data.length === 0) {
                // self.gridApi.setRowData([{}]);
                this.$snotify.success('Sin Datos');
                self.gridApi.showNoRowsOverlay();
                params.successCallback([{}], 0);
              } else {
                params.successCallback(
                  response.data.data,
                  response.data.total
                );
                self.gridApi.hideOverlay();
              }
            } else {
              this.$snotify.error('Error al traer los registros');
            }
          })
          .catch((error: any) => {
            console.log(error);
          })
          .finally(() => {
            self.gridApi.setDomLayout('autoHeight');
          });
      },
    };
    // this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
    this.gridApi.setServerSideDatasource(this.serverSide);
    this.loadingService.hideLoading();
  }

  // async intervalSearchReports() {
  //   this.loadingService.showLoading();
  //   this.gridApi.setServerSideDatasource(this.serverSide);
  // }

  isExternalFilterPresent(): boolean {
    return true;
  }

  changeChannels() {
    var channels: any[] = [{ cod: '', desc: 'Todos' }];
    var channelsPatent: any[] = this.formFields.patent.items.filter(
      (item: any) => item.cod == this.formFields.patent.value
    );
    if (channelsPatent.length > 0) {
      if (channelsPatent[0].channels != null) {
        channelsPatent = channelsPatent[0].channels.map((item: any) => {
          return { cod: item, desc: item };
        });
        channels = channels.concat(channelsPatent);
        this.formFields.channels.items = channels;
        this.formFields.channels.value = '';
      }
    }
  }

  textoComprimido(item: any) {
    let retorno: string = '';
    if (item.length > 14) {
      retorno = item.substr(0, 13) + '...';
    } else {
      retorno = item;
    }
    return retorno;
  }

  getStateString(state: string): string {
    var stateString: string = '';
    if (state == 'Linea') {
      stateString = 'En Línea';
    } else if (state == 'Desconecta') {
      stateString = 'Desconectado';
    } else if (state == 'Sin Info') {
      stateString = 'Sin Información';
    }
    return stateString;
  }

  getHtmlFromState(state: string): string {
    const style =
      'width: 24px; height: 24px;margin-top: 2%; border-radius: 50%; ';
    var html = '';
    var css = '';
    if (state == 'Linea') {
      css = style + ' background: rgb(42, 255, 78)';
    } else if (state == 'Desconecta') {
      css = style + ' background: rgb(255, 58, 58)';
    } else if (state == 'Sin Info') {
      css = style + ' background: rgb(33, 33, 255)';
    }
    return css;
  }

  handleVideo(url: any, type: string, urlConverter: string) {
    if (type == 'ver') {
      this.isDownload = false;
      this.titleDialog = 'Visualizador de video';
      this.showVideo(url, urlConverter);
    } else if (type == 'descargar') {
      this.isDownload = true;
      this.titleDialog = 'Descargar video';
      this.downloadVideo(url, urlConverter);
    }
  }

  doesExternalFilterPass(node: RowNode): boolean {
    return true;
  }

  handleClear() {
    this.formFields.patent.value = [];
    this.formFields.patente.value = [];
    this.formFields.dateStart.value = moment(
      this.dateString.getFullYear() +
        '-' +
        (this.dateString.getMonth() + 1).toString() +
        '-' +
        this.dateString.getDate()
    );
    (this.formFields.timeStart.value = moment('00:00', 'HHmm')),
      (this.formFields.dateEnd.value = moment(
        this.dateString.getFullYear() +
          '-' +
          (this.dateString.getMonth() + 1).toString() +
          '-' +
          this.dateString.getDate()
      ));
    this.formFields.timeEnd.value = moment('23:59', 'HHmm');
    this.checkAllFlotas = false;
    this.checkAllVehiculos = false;
    this.search = '';
  }

  async handleClick() {
    this.gridApi.deselectAll();
    const resultadoValidacion = await this.$validator.validateAll();
    if (resultadoValidacion) {
      const date_start = moment(this.formFields.dateStart.value.toString())
        .format('YYYY-MM-DD')
        .toString();
      const time_start =
        moment(this.formFields.timeStart.value.toString())
          .format('HH:mm')
          .toString() + ':00';
      const date_end = moment(this.formFields.dateEnd.value.toString())
        .format('YYYY-MM-DD')
        .toString();
      const time_end =
        moment(this.formFields.timeEnd.value.toString())
          .format('HH:mm')
          .toString() + ':00';

      this.startDateFetch = date_start + ' ' + time_start;
      this.endDateFetch = date_end + ' ' + time_end;
      this.cameraFetch = this.formFields.patent.value;
      //this.patentFetch = this.patentFormat;

      this.gridApi.setServerSideDatasource(this.serverSide);
    }
  }

  async chargeFlotasCamera() {
    this.loadingService.showLoading();
    //const body: {} = {id_cliente: this.getClientID()};
    const body: {} = {
      id_cliente: this.getClientID(),
      id_usuario: this.getUserID().toString(),
      clienteDefecto: this.getClientID(),
      rut: this.getRut(),
    };
    var self = this;
    fetchCamaraModulo(body, 'getFlotasHik')
      .then((response: any) => {
        self.formFields.patent.items = response.data.data || [];
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        self.loadingService.hideLoading();
        self.chargePatentsCamera();
      });
  }

  async chargePatentsCamera() {
    this.loadingService.showLoading();
    //const body: {} = {id_cliente: this.getClientID()};
    const body: {} = {
      id_cliente: this.getClientID(),
      id_usuario: this.getUserID().toString(),
      clienteDefecto: this.getClientID(),
      rut: this.getRut(),
      flotas: this.formFields.patent.value,
    };
    var self = this;
    fetchCamaraModulo(body, 'getVehiculosHik')
      .then((response: any) => {
        self.formFields.patente.items = response.data.data || [];
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
    self.loadingService.hideLoading();
  }

  async downloadVideo(videoUrl: string, urlConverter: string) {
    this.loadingService.showLoading();
    var video: string = await this.getVideo(videoUrl, urlConverter);
    if (video != '') {
      this.isDownload = true;
      this.videoUrl = video;
      this.openVideo = true;
    }
    this.loadingService.hideLoading();
  }

  get fechaMaxima() {
    const fechaMax = moment().format('YYYY-MM-DD h:mm:ss a');
    return fechaMax;
  }

  async showVideo(videoUrl: string, urlConverter: string) {
    this.loadingService.showLoading();
    var video: string = await this.getVideo(videoUrl, urlConverter);
    if (video != '') {
      this.isDownload = false;
      this.videoUrl = video;
      this.openVideo = true;
    }
  }

  async getVideo(videoUrl: string, urlConverter: string): Promise<string> {
    try {
      var response = await axios.post(urlConverter, { url: videoUrl });
      this.loadingService.hideLoading();
      if (response.data.CODIGO_RESPUESTA == '1') {
        return response.data.data.new_url;
      } else {
        this.$snotify.error('Hubo un error al intentar abrir el video');
        return '';
      }
    } catch (error) {
      console.log(error);
      this.$snotify.error('Hubo un error al intentar abrir el video');
      this.loadingService.hideLoading();
      return '';
    }
  }

  //get patentFormat(): string {
  //  return;
  //}

  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
    // return 5216;
  }
  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }
  getRut(): any {
    let rut = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user').replace(/'/g, '"'))
          .rutClienteDefecto
      : '';
    return rut;
  }
}
